export default __webpack_public_path__ + "static/media/trash-solid.196549b2.svg";